import { M8DebitSortableField } from 'services/production/types';
import { BillsTableSortableField } from 'types/state';
import { UnreachableError } from 'utils/errors';

export const normalizeBillsTableSortableField = (
  billsTableSortableField: BillsTableSortableField
) => ({
  toM8BillRowSortableField(): M8DebitSortableField {
    switch (billsTableSortableField) {
      case 'id':
        return 'id';
      case 'status':
        return 'debitStatus';
      case 'issuedAt':
        return 'createdOn';
      case 'fullName':
        return 'user.lastName';
      case 'organization':
        return 'user.organization';
      case 'resident':
        return 'user.residentInfo.resident';
      case 'amountEUR':
        return 'exchangedAmount.eurAmount';
      case 'amountRUB':
        return 'exchangedAmount.rubAmount';
      case 'amount':
        return 'amount';
      default:
        throw new UnreachableError(billsTableSortableField);
    }
  },
});
